import global from "global";

const onTransitionEnd = ({ target: element }) => {
  element.style.transition = "";
  element.removeEventListener("transitionend", onTransitionEnd);
};

const onTransitionMidPoint = ({ target: element }) => {
  element.removeEventListener("transitionend", onTransitionMidPoint);

  element.style.transform = "";
  element.style.transitionDuration = "0.5s";
  element.style.transitionDelay = "0";
  element.style.opacity = "1";

  element.addEventListener("transitionend", onTransitionEnd);
};

const triggerAnimation = ({ toAnimate }) => {
  toAnimate.forEach(({ element, moveDiagonally }, index) => {
    const initialDelayMs = index * 25;

    if (moveDiagonally) {
      element.style.transition = "opacity";
      element.style.transitionTimingFunction = "ease-out";
      element.style.transitionDuration = "0.2s";
      element.style.transitionDelay = `${initialDelayMs}ms`;
      element.style.opacity = "0";

      element.addEventListener("transitionend", onTransitionMidPoint);
    } else {
      element.style.transition = "transform 0.7s";
      element.style.transitionDelay = `${initialDelayMs}ms`;
      element.style.transform = "";

      element.addEventListener("transitionend", onTransitionEnd);
    }
  });
};

const animateElements = ({ toAnimate }) => {
  if (!toAnimate.length) {
    return;
  }

  let innerAnimationFrameReq;
  const outerAnimationFrameReq = global.requestAnimationFrame(() => {
    innerAnimationFrameReq = global.requestAnimationFrame(() => {
      triggerAnimation({ toAnimate });
    });
  });

  return () => {
    global.cancelAnimationFrame(outerAnimationFrameReq);
    global.cancelAnimationFrame(innerAnimationFrameReq);
  };
};

export default animateElements;
